/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Přidat k objednávce",
  "i18n.additionalProducts.emotionalHook": "♥️ Velmi oblíbený:",
  "i18n.additionalProducts.productDescription": "Popis produktu",
  "i18n.additionalProducts.showMore": "Více informací",
  "i18n.additionalProducts.title": "Vhodné pro příslušenství",
  "i18n.button.addToCart": "Vložit do košíku",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Potvrdit",
  "i18n.button.back": "Zpět",
  "i18n.button.cancel": "Storno",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Zavřít",
  "i18n.button.continue": "Pokračovat",
  "i18n.button.ignore": "Storno",
  "i18n.button.ignoreAndContinue": "Přesto pokračovat",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Bez SMART SORTED",
  "i18n.button.design": "",
  "i18n.button.photos": "Fotografie",
  "i18n.button.retry": "Obnovit",
  "i18n.button.uploadPhotos": "Nahrát fotografii(e)",
  "i18n.button.withSmartSorted": "SMART SORTED",
  "i18n.button.withoutSmartSorted": "Bez SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Pro lepší čitelnost zkraťte prosím text.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Vybraný typ písma je příliš dlouhý pro tento text.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Byla dosažena maximální možná velikost písma.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Byla dosažena minimální možná velikost písma.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Prosím vložte zalomení textu",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Pokračujte v psaní na další řádek nebo zvětšete textové pole.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Zkontrolujte zadaný text. Toto písmo nepodporuje všechny znaky.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Pro lepší čitelnost zkraťte prosím text.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "prosím zvětšete textové pole",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Tento krok nelze udělat zpětně",
  "i18n.dialog.deletePlaceholder.title": "Opravdu smazat?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "Rozlišení této fotografie je příliš nízké na to, aby se fotografie vytiskla ostře a detailně!",
  "i18n.dialog.smartSorted.message": "Se SMART SORTED složíte bez námahy Váš motiv s 1000 dílky, a to i bez  předlohy",
  "i18n.dialog.smartSorted.title": "Úspěch zaručen",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Pro změnu textu na krabičce klikněte prosím na \"{{text}}\".",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Text na krabičce nebyl změněn",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Pokračovat bez textu na krabičce",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Fotografii vložíte kliknutím na symbol obrázku",
    "Fotografie vložíte kliknutím na symboly obrázků",
    "Fotografie vložíte kliknutím na symboly obrázků"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "Nebyla vložena jedna fotografie",
    "Nebylo vloženo více fotografií",
    "Nebylo vloženo více fotografií"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Nebyla nahrána fotografie.",
    "Nebylo nahráno více fotografií.",
    "Nebylo nahráno více fotografií."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Pro změnu textu klikněte prosím na kolonku s textem",
    "Pro změny textů klikněte prosím na kolonky s textem",
    "Pro změny textů klikněte prosím na kolonky s textem"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Kolonka s textem nebyla změněna",
    "Kolonky s texty nebyly změněny",
    "Kolonky s texty nebyly změněny"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "Chybějící fotografie",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Návrhu jste se delší dobu nevěnovali, proto ho nelze dokončit. Začněte prosím od začátku. ",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Fotografie nemohla být nahrána. Byla odstraněna z galerie a z plochy.",
  "i18n.error.imageLoadingError.title": "Chyba stahování",
  "i18n.error.imageProvisionError.message": "Jedna nebo více fotografií nemohlo být zpracováno. Pravděpodobně nejsou v podporovaném formátu.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "Soubor \"{{reference1}}\" nemohl být zpracován",
  "i18n.error.imageSelectionError.title": "Chyba během nahrávání fotografie",
  "i18n.error.imageSizeLimitExceededError.message": "Nahraný obrázek je příliš velký.\nZmenšete ho prosím na méně než 180 megapixelů a zkuste ho nahrát znovu.",
  "i18n.error.imageSizeLimitExceededError.title": "Chyba během nahrávání fotografie",
  "i18n.error.imageUploadError.message": "Vyskytla se chyba v internetovém připojení. Prosím zkuste to znovu později.",
  "i18n.error.imageUploadError.title": "Chyba během nahrávání fotografie",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "Tento typ písma nelze použít, vyberte prosím jiný",
  "i18n.error.invalidCharConfigError.title": "Typ písma není použitelné",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "Zdá se, že Vaše internetové připojení bylo přerušeno. S vytvářením produktu můžete pokračovat hned, jakmile bude obnoveno.",
  "i18n.error.templateLoadingError.message": "Šablona \"{{ error.reference[0] }}\" nemohla být nahrána.\nProsím zkuste to později.",
  "i18n.error.templateLoadingError.title": "Chyba stahování",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" je v nepodporovaném formátu.",
  "i18n.error.unsupportedMediaTypeError.title": "Chyba během nahrávání fotografie",
  "i18n.error.uploadProductError.message": "Jeden nebo několik produktů nebylo přeneseno na server.\nProsím zkuste to znovu později.",
  "i18n.error.uploadProductError.title": "Chyba přenosu.",
  "i18n.error.zoomModeError.message": "Váš text z předchozího návrhu nelze převzít. Zadejte prosím nový text.",
  "i18n.error.zoomModeError.title": "Text nebyl přijat",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Cena",
  "i18n.price.reduction": "Ušetříte",
  "i18n.price.total": "Celková cena",
  "i18n.priceDisplay.times": [
    "{{value}} kus za {{pricePerUnit}}",
    "{{value}} kusy každý za {{pricePerUnit}}",
    "{{value}} kusů každý za {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Vyberte příslušenství",
  "i18n.progressOverlay.message.lines.one": "Děkujeme za vytvoření tohoto hezkého výrobku.",
  "i18n.progressOverlay.message.lines.two": "Vše pro Vás připravíme...",
  "i18n.template.insertText": "Zde zadejte text",
  "i18n.toolbox.image.title": "Úprava fotografie",
  "i18n.toolbox.layout.template.count": [
    "",
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 fotka",
    "{{value}} fotky",
    "{{value}} fotek"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "3D náhled",
  "i18n.toolbox.productChooser.title": "Změna produktu",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Upravit text",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocaleCsCZ {
  public getPlural(n: number): number
  {
    const pluralForm = (n==1) ? 0 : (n>=2 && n<=4) ? 1 : 2;
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
